const locationFacilityTypes = {
  create: 'Create',
  update: 'Update',
  facilityType: {
    school: 'School',
    work: 'Workplace',
  },
  toasts: {
    delete: {
      success: '[Location Facility] has been deleted successfully',
      errorMessage: 'Something went wrong. Please try again later.',
    },
    create: {
      success: '[Location Facility] has been created successfully',
      error: '[Location Facility] bad server response',
    },
    update: {
      success: '[Location Facility] has been update successfully',
      error: '[Location Facility] bad server response',
    },
  },
  deleteModal: {
    header: 'Delete Facilities',
    body: 'Are you sure you want to delete {{num}} facilities?',
  },
  table: {
    headers: {
      name: 'Name',
      type: 'Type',
      facilityTypes: 'Type',
      contactName: 'Contact',
      email: 'Email',
      phone: 'Phone Number',
      address: 'Address',
      profile: 'Profile',
    },
    filters: {
      type: 'Type',
    },
    actions: {
      delete: 'Delete',
    },
  },
  form: {
    tabs: {
      general: 'Location Info',
      contact: 'Contact Info',
      hours: 'Hours',
      advancedSettings: 'Preferences',
      holidays: 'Holidays',
    },
    forms: {
      general: {
        header: '{{type}} Location',
        fields: {
          name: '{{type}} Name',
          address: '{{type}} Address',
          type: 'Facility Type',
          radius: {
            title: 'Address Matching Radius',
            description:
              'The radius in meters or feet (m/ft for metric/imperial) within which reservations are recognized as the location and or as wait-and-return.',
          },
        },
      },
      contacts: {
        header: 'Contact: {{index}}',
        fields: {
          comment: 'Comment',
          address: 'Address',
          fax: 'Fax',
          phone: 'Phone',
          email: 'Email',
          type: 'Type',
          name: 'Name',
        },
        actions: {
          add: 'Add Contact +',
        },
      },
      shiftsHours: {
        header: {
          school: 'School Hours',
          work: 'Work Hours',
        },
        fields: {
          name: 'Name',
          status: 'Status',
          start: 'Start',
          end: 'End',
          type: {
            title: 'Type',
            options: {
              collect: 'Collect',
              distribute: 'Distribute',
              both: 'Both',
            },
          },
          weekDays: 'Week Days',
        },
        actions: {
          add: {
            default: '+ Add',
            school: '+ Add School Hours',
            work: '+ Add Work Hours',
          },
        },
      },
      reservationPreferences: {
        header: 'Reservation Preferences',
        fields: {
          sharedWithOther: 'Shared With Other',
          profile: 'Profile',
          suppliers: 'Suppliers',
          service: 'Service',
        },
      },
      advancedSettings: {
        header: 'Advanced Settings',
        fields: {
          consistentPassengerRouting: {
            title: 'Consistent Passenger Routing',
            toolTipInformation:
              'Ensures that the same group of passengers always follows the same route to and from the facility, optimizing travel efficiency and minimizing confusion.',
          },
          sameDriverForGroup: {
            title: 'Same Driver for Group',
            toolTipInformation:
              'Assigns the same driver to transport the group of passengers for both pick-up and drop-off, providing familiarity and consistency for passengers.',
          },
          allowSharedRide: {
            title: 'Allow Shared Ride With Other Addresses',
            toolTipInformation:
              'When enabled, this setting allows shared rides to be grouped with bookings from other locations that have consistent routes. If disabled, only rides from the same location will be considered for grouping.',
          },
          tripBoardingTime: {
            title: 'Boarding Time',
            toolTipInformation: 'The time it takes to pick up a passenger on their stop (This parameter will impact overall trip duration)',
          },
          waitForBoardingTime: {
            title: 'Wait For Boarding Time',
            toolTipInformation: 'When reaching a stop, the driver will wait until the exact pick-up time, if needed.',
          },
          tripDropOffTime: {
            title: 'Drop-off Time',
            toolTipInformation: 'The time it takes to drop a passenger on their stop (This parameter will impact overall trip duration)',
          },
          rules: {
            header: 'Location / Profiles Rules',
            rule: 'Rule',
            profiles: 'Profiles',
            addNewRule: '+ Add Location / Profile Rule',
          },
          maxDropOffEarly: {
            title: 'Max Drop-off Early',
            toolTipInformation: 'Maximum number of minutes a driver can get early relative to the drop-off time set in the reservation',
          },
          maxDropOffDelay: {
            title: 'Max Drop-off Delay',
            toolTipInformation: 'Maximum number of minutes a driver can be late for the drop off time set in the reservation',
          },
          maxBoardingDelay: {
            title: 'Max Boarding Delay',
            toolTipInformation: 'Maximum number of minutes a driver can be late for the pickup time set in the reservation',
          },
          maxBoardingEarly: {
            title: 'Max Boarding Early',
            toolTipInformation: 'Maximum number of minutes a driver can get early relative to the pickup time set in the reservation',
          },
          maxTripDuration: {
            title: 'Max Trip Duration',
            toolTipInformation: 'Maximum duration of a trip in minutes',
          },
          maxSinglePassengerTime: {
            title: 'Max Single Passenger Trip Time',
            toolTipInformation: 'Maximum duration of a trip in minutes per passenger',
          },
        },
      },
      excludedDrivers: {
        header: 'Excluded Drivers',
        fields: {
          driversList: 'Drivers List',
          excludedList: 'Excluded List'
        }
      },
      excludedVehicles: {
        header: 'Excluded Vehicles',
        fields: {
          vehiclesList: 'Vehicles List',
          excludedList: 'Excluded List'
        }
      },
      excludeHolidays: {
        header: 'Excluded Holidays',
        fields: {
          holidaysList: 'Holidays List',
          excludedList: 'Excluded Holidays'
        }
      }
    },
  },
};

export default locationFacilityTypes;
